import * as THREE from 'three'

const coneVertices: Array<THREE.Vector3> = [
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0, 1, 0),
    new THREE.Vector3(1, 1, 0),

    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(1, 1, 0),
    new THREE.Vector3(1, 0, 0),

    new THREE.Vector3(0, 1, 0),
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0.5, 0.5, 1),

    new THREE.Vector3(1, 1, 0),
    new THREE.Vector3(0, 1, 0),
    new THREE.Vector3(0.5, 0.5, 1),

    new THREE.Vector3(1, 0, 0),
    new THREE.Vector3(1, 1, 0),
    new THREE.Vector3(0.5, 0.5, 1),

    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(1, 0, 0),
    new THREE.Vector3(0.5, 0.5, 1),
]

const markerMaterial_hidden = new THREE.MeshStandardMaterial({
    color: 0xcccccc,
    roughness: 0.5,
    metalness: 0.1,
    transparent: true,
    opacity: 0,
})

const markerMaterial_hover = new THREE.MeshStandardMaterial({
    color: 0xffff00,
    roughness: 0.5,
    metalness: 0.1,
})

const markerMaterial_inactive = new THREE.MeshStandardMaterial({
    color: 0xcccccc,
    roughness: 0.5,
    metalness: 0.1,
})

const markerMaterial_selected = new THREE.MeshStandardMaterial({
    color: 0x00ff00,
    roughness: 0.9,
    metalness: 0.9,
})

function volumetricSpotLightMaterial() {
    //
    const vertexShader = [
        'varying vec3 vNormal;',
        'varying vec3 vWorldPosition;',

        'void main(){',
        '// compute intensity',
        'vNormal		= normalize( normalMatrix * normal );',

        'vec4 worldPosition	= modelMatrix * vec4( position, 1.0 );',
        'vWorldPosition		= worldPosition.xyz;',

        '// set gl_Position',
        'gl_Position	= projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
        '}',
    ].join('\n')
    const fragmentShader = [
        'varying vec3		vNormal;',
        'varying vec3		vWorldPosition;',
        'uniform vec3		lightColor;',
        'uniform vec3		spotPosition;',
        'uniform float		attenuation;',
        'uniform float		anglePower;',
        'void main(){',
        'float intensity;',

        // distance attenuation
        'intensity	= distance(vWorldPosition, spotPosition)/attenuation;',
        'intensity	= 1.0 - clamp(intensity, 0.0, 1.0);',

        // intensity on angle
        'vec3 normal	= vec3(vNormal.x, vNormal.y, abs(vNormal.z));',
        'float angleIntensity	= pow( dot(normal, vec3(0.0, 0.0, 1.0)), anglePower );',
        'intensity	= intensity * angleIntensity;',

        // set the final color
        'gl_FragColor	= vec4( lightColor, intensity);',
        '}',
    ].join('\n')

    // create custom material from the shader code above
    //   that is within specially labeled script tags
    const material = new THREE.ShaderMaterial({
        uniforms: {
            attenuation: {
                type: 'f',
                value: 100.0,
            },
            anglePower: {
                type: 'f',
                value: 1.2,
            },
            spotPosition: {
                type: 'v3',
                value: new THREE.Vector3(0, 0, 0),
            },
            lightColor: {
                type: 'c',
                value: new THREE.Color('white'),
            },
        },
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        // side		: THREE.DoubleSide,
        // blending	: THREE.AdditiveBlending,
        transparent: true,
        depthWrite: false,
    })
    return material
}

export {
    coneVertices,
    volumetricSpotLightMaterial,
    markerMaterial_hidden,
    markerMaterial_hover,
    markerMaterial_inactive,
    markerMaterial_selected
}